// extracted by css-extract-rspack-plugin
export default {"cls1":"RotatingPreview-cls1_hkZ","cls2":"RotatingPreview-cls2_Ba0 RotatingPreview-cls1_hkZ"};